import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Price display with optional weight and discount badge. */
export function CardPrice(): JSX.Element {
  const {
    displayPrice,
    standardPrice,
    discount,
    showWeight,
    weight,
    listPriceEnabled,
    hideStrikethrough,
    formatStandardPrice,
  } = useCardContext();

  return (
    <Price>
      <ActivePrice>
        {displayPrice}
        {showWeight && <Weight> - {weight}</Weight>}
      </ActivePrice>

      {discount && (
        <DiscountedPrice>
          <OriginalPrice $listPriceEnabled={listPriceEnabled} $hideStrikethrough={hideStrikethrough}>
            {standardPrice && listPriceEnabled ? formatStandardPrice(standardPrice) : standardPrice}
          </OriginalPrice>
          {!hideStrikethrough && <Discount $listPriceEnabled={listPriceEnabled}>{discount}</Discount>}
        </DiscountedPrice>
      )}
    </Price>
  );
}

const Price = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;
  margin: 16px 0 8px;
  width: 100%;
`;

const ActivePrice = styled.div`
  color: #2c3236;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
`;

const Weight = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: ${20 / 14};
`;

const DiscountedPrice = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: var(--justify-content);
`;

const OriginalPrice = styled.div<{ $listPriceEnabled?: boolean; $hideStrikethrough?: boolean }>`
  color: ${({ $listPriceEnabled }) => ($listPriceEnabled ? 'var(--dcm-product-detail-muted-color)' : '#485055')};
  font-size: ${({ $listPriceEnabled }) => ($listPriceEnabled ? '12px' : '14px')};
  line-height: 1;
  text-decoration: ${({ $hideStrikethrough }) => ($hideStrikethrough ? 'none' : 'line-through')};
`;

const Discount = styled.div<{ $listPriceEnabled?: boolean }>`
  background: ${({ $listPriceEnabled, theme }) =>
    $listPriceEnabled ? 'var(--dcm-product-discount-color, #d34a4a)' : theme.customized.colors.discountTag};
  border-radius: ${({ $listPriceEnabled, theme }) => ($listPriceEnabled ? '4px' : theme.customized.radius.tags)};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 1;
  margin-left: 2px;
  padding: 2px 6px;
  white-space: nowrap;
`;
